// extracted by mini-css-extract-plugin
module.exports = {"numberedPage":"MimaTable_numberedPage__WT6g2","numberPageActive":"MimaTable_numberPageActive__Y7v0z","pagination":"MimaTable_pagination__xVwu0"};